"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Menu = _interopRequireDefault(require("./Menu.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Menu = function Menu(_ref) {
  var lang = _ref.lang;
  var css = (0, _Menu.default)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    localsLoaded = _useState2[0],
    setLocalsLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var location = (0, _reactRouterDom.useLocation)();
  var navigate = (0, _useLink.default)();
  var _ref2 = location || {},
    pathname = _ref2.pathname;
  var theme = (0, _useTheme.default)();
  var isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(l("reactShop"))) {
      setLocalsLoaded(true);
    }
  }, [l]);
  var menuGroup = (0, _react.useMemo)(function () {
    return [{
      identifier: "products",
      title: l("reactShop.myAccount.menu.labels.digitalProducts"),
      link: "/".concat(lang, "/shop/myaccount/products")
    }, {
      identifier: "orders",
      title: l("reactShop.myAccount.menu.labels.orders"),
      link: "/".concat(lang, "/shop/myaccount/orders")
    }, {
      identifier: "customer",
      title: l("reactShop.myAccount.menu.labels.customer"),
      link: "/".concat(lang, "/shop/myaccount/customer")
    }, {
      identifier: "addresses",
      title: l("reactShop.myAccount.menu.labels.addresses"),
      link: "/".concat(lang, "/shop/myaccount/addresses")
    }, {
      identifier: "logout",
      title: l("reactShop.myAccount.menu.labels.logout"),
      link: "/".concat(lang, "/shop/logout")
    }];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, localsLoaded]);
  (0, _react.useEffect)(function () {
    var index = menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.findIndex(function (_ref3) {
      var link = _ref3.link;
      return pathname === link;
    });
    setValue(index !== null && index !== void 0 ? index : 0);
  }, [pathname, menuGroup]);
  var handleChange = function handleChange(event, newValue) {
    var _menuGroup$newValue;
    var link = menuGroup === null || menuGroup === void 0 ? void 0 : (_menuGroup$newValue = menuGroup[newValue]) === null || _menuGroup$newValue === void 0 ? void 0 : _menuGroup$newValue.link;
    if (!link) return;
    navigate(link);
    setValue(newValue);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(css.menu, "mco-shop-myaccount-menu")
  }, isMobile ? /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    classes: {
      root: (0, _clsx3.default)(css.tabs, "mco-shop-myaccount-menu__tabs")
    },
    indicatorColor: "primary",
    scrollButtons: "auto",
    textColor: "primary",
    value: value,
    variant: "scrollable",
    onChange: handleChange
  }, menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.map(function (_ref4, index) {
    var identifier = _ref4.identifier,
      link = _ref4.link,
      title = _ref4.title;
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      classes: {
        root: (0, _clsx3.default)(css.tab, "mco-shop-myaccount-menu__tab", _defineProperty({}, css.tabActive, pathname.indexOf(link) > -1 && link !== "/".concat(lang, "/shop/myaccount")))
      },
      "data-identifier": identifier,
      key: index,
      label: title
    });
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.title
  }, /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    to: "/".concat(lang, "/shop/myaccount")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.myAccount.menu.title",
    l: l
  }))), /*#__PURE__*/_react.default.createElement("ul", {
    className: css.list
  }, menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.map(function (_ref5, index) {
    var _clsx2;
    var identifier = _ref5.identifier,
      link = _ref5.link,
      title = _ref5.title;
    var isActive = pathname.indexOf(link) > -1 && link !== "/".concat(lang, "/shop/myaccount");
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _clsx3.default)(css.item, "mco-shop-myaccount-menu__link"),
      "data-identifier": identifier,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
      className: (0, _clsx3.default)(css.link, (_clsx2 = {}, _defineProperty(_clsx2, css.linkActive, isActive), _defineProperty(_clsx2, "mco-shop-myaccount-menu__link--active", isActive), _clsx2)),
      to: link
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      component: "span"
    }, title)));
  }))));
};
var _default = Menu;
exports.default = _default;